import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { CustomerDP } from '../../admin/models/customer-dp.model';
import { toHttpParams } from '../project/helpers/to-http-params';

@Injectable()
export class AdminCustomerDPService {
  constructor(private http: HttpClient) {}
  /**
   * Get all customer DPs
   */
  getCustomerDPsForAdmin() {
    return this.http.get<CustomerDP[]>(`${environment.apiConfig.url}/admin/customer-dps/summaries`);
  }

  getCustomerDPsCsvForAdmin() {
    const url = `${environment.apiConfig.url}/admin/customer-dps/summaries`;
    const params = toHttpParams({ dataFormat: 'csv' });

    return this.http.get(url, {
      params,
      headers: { Accept: 'application/octet-stream' },
      responseType: 'blob',
    });
  }

  deleteCustomerDPByIdForAdmin(id: string) {
    const url = `${environment.apiConfig.url}/admin/customer-dps/${id}`;
    return this.http.delete(url);
  }
}
